import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
var _hoisted_1 = {
    key: 0,
    class: "process-spinner flex gap-4 w-full bg-white items-center content-center justify-center"
};
var _hoisted_2 = /*#__PURE__*/ _createElementVNode("div", { class: "bounce1 bg-blue-400" }, null, -1);
var _hoisted_3 = /*#__PURE__*/ _createElementVNode("div", { class: "bounce2 bg-blue-400" }, null, -1);
var _hoisted_4 = /*#__PURE__*/ _createElementVNode("div", { class: "bounce3 bg-blue-400" }, null, -1);
var _hoisted_5 = [
    _hoisted_2,
    _hoisted_3,
    _hoisted_4
];
export default /*#__PURE__*/ _defineComponent({
    __name: 'LoadingProcessing',
    props: {
        isLoading: { type: Boolean, required: false, default: false },
    },
    emits: [
        'onDoAction',
    ],
    setup: function (__props, _a) {
        var emit = _a.emit;
        var props = __props;
        var onDoAction = function () {
            emit('onDoAction');
        };
        return function (_ctx, _cache) {
            return (__props.isLoading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_5))
                : _createCommentVNode("", true);
        };
    }
});
